import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideIcons } from './shared/icons/icons.provider';
import { QuillModule } from 'ngx-quill';
import { ReactiveFormsModule } from '@angular/forms';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { provideToastr } from 'ngx-toastr';
import { provideLottieOptions } from 'ngx-lottie';

import { provideNativeDateAdapter } from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { provideAsistenciaMml } from './admin/asistencia-mml/asistencia-mml.providers';
import { provideSplitsMml } from './admin/splits/splits.providers';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideToastr({timeOut: 2000, preventDuplicates: true}),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'disabled'
    })), 
    provideAnimationsAsync(),
    provideIcons(),
    
    // AGREGAR ESTE PROVIDER PARA EL DATEPICKER
    provideNativeDateAdapter(),
    
    importProvidersFrom(
      ReactiveFormsModule,
      QuillModule.forRoot(),
      // AGREGAR TAMBIÉN ESTO POR COMPATIBILIDAD
      MatNativeDateModule
    ),
    { provide: LOCALE_ID, useValue: 'es' },
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideServiceWorker('ngsw-worker.js', {
      // `isDevMode()` no sirve como gate aquí: la configuración "production" de angular.json
      // tiene optimization:false, así que ngDevMode no se elimina en el build y isDevMode()
      // seguiría devolviendo true. environment.production sí queda correctamente en `true`
      // porque angular.json reemplaza environment.ts por environment.production.ts (fileReplacements).
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ...provideAsistenciaMml(),
    ...provideSplitsMml(),
  ],
};